// ─── App switcher ─────────────────────────────────────────────────────────────
// Every storefront in the family, for the dropdown in the header. Identical in all six
// apps — copy it over rather than editing one copy, so the menus cannot drift apart
// again (they had: nobody linked ACE DRIVE, ACC ACADEMY was missing two entries, and
// iR DRIVE was still listed under its old host).
//
// The logo is read from the target site's own /logo192.png instead of being bundled
// here. A redesigned logo then has to be deployed once, on the app it belongs to,
// rather than copied into six repos and rebuilt six times.

export interface AppLink {
  name: string;
  url: string;
  logo: string;
}

const SITES = [
  { name: "ACC DRIVE", url: "https://accdrive.com" },
  { name: "ACC ACADEMY", url: "https://academy.accsolutions.de" },
  { name: "iR DRIVE", url: "https://irdrive.de" },
  { name: "LMU DRIVE", url: "https://lmudrive.com" },
  { name: "AC DRIVE", url: "https://acdrive.simracingsolutions.de" },
  { name: "ACE DRIVE", url: "https://acedrive.simracingsolutions.de" },
  { name: "ACC TV", url: "https://acctv.de" },
];

export const APPS: AppLink[] = SITES.map((site) => ({
  ...site,
  logo: `${site.url}/logo192.png`,
}));

/**
 * Every app except the one currently being viewed, matched on the host. Doing it by
 * host instead of a per-app constant is what keeps this file byte-identical across the
 * six repos. On localhost nothing matches and the full list shows, which is harmless.
 */
export function otherApps(host: string = window.location.hostname): AppLink[] {
  return APPS.filter((app) => {
    try {
      return new URL(app.url).hostname !== host;
    } catch {
      return true;
    }
  });
}
